import { z } from 'zod';
/** Read-only leave details; Sprout reasons and approver identities are excluded. */
export const allocationDoerLeavesResponseSchema = z.object({
    source: z.literal('sprout'),
    readAt: z.string(),
    window: z.object({ from: z.string(), to: z.string() }).strict(),
    leaves: z.array(z.object({
        id: z.string(),
        startDate: z.string().nullable(),
        endDate: z.string().nullable(),
        type: z.string().nullable(),
        status: z.enum(['pending', 'approved', 'denied', 'cancelled', 'unknown']),
    }).strict()),
}).strict();
//# sourceMappingURL=allocation-doer-leaves.js.map